import { render, staticRenderFns } from "./ArticleView.vue?vue&type=template&id=0a59bd94&"
import script from "./ArticleView.vue?vue&type=script&lang=js&"
export * from "./ArticleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports